import React from 'react';
import { AlertTriangleIcon, CheckIcon, StarIcon } from 'lucide-react';
import { purchaseUrls } from '../data/content';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
const baseFeatures = ['6 Tomos PDF completos (Evaluación, Intervenciones, Familias, Contextos, Informes y 50 Casos)', '6 Bonos estratégicos incluidos gratis', '+300 actividades y +200 juegos terapéuticos clasificados', 'Formularios profesionales listos para usar', 'Acceso inmediato en 5 minutos', 'Garantía de devolución de 7 días'];
const premiumFeatures = ['TODO el Combo Completo AT (6 Tomos + 6 Bonos)', '+500 intervenciones clasificadas por diagnóstico', 'Protocolos de actuación crítica para crisis y emergencias', 'Planificaciones maestras de 30, 60 y 90 días', 'Banco de objetivos técnicos por nivel funcional', 'Herramientas de ahorro de tiempo profesional'];
function PlanCard({
  premium = false
}: {
  premium?: boolean;
}) {
  const features = premium ? premiumFeatures : baseFeatures;
  const title = premium ? 'Combo Completo AT + Mega Kit de Intervención' : 'Combo Completo AT';
  const subtitle = premium ? '6 Tomos + 6 Bonos + 50 páginas de intervención avanzada' : '6 Tomos + 6 Bonos';
  const price = premium ? '$27.990' : '$19.990';
  const before = premium ? '$95.000' : '$72.000';
  const savings = premium ? '$67.000' : '$52.010';
  return <article className={`relative flex flex-col rounded-3xl p-6 md:p-8 ${premium ? 'border-4 border-gold bg-primary text-white shadow-[0_25px_60px_rgba(2,132,199,.4)] ring-4 ring-gold/30 md:scale-[1.025]' : 'border-2 border-celeste/50 bg-white shadow-sm'}`} data-id="element-273" data-mp="2ylx1qndovzgs">
      {premium && <div className="absolute -top-4 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full border-2 border-amber-200 bg-gold px-4 py-1.5 text-xs font-extrabold uppercase text-white shadow-lg" data-id="element-274" data-mp="33ehudlkv06iq">
          <StarIcon className="h-4 w-4 fill-current" data-id="element-275" data-mp="3cfoavunidhbz" /> 🏆 Más elegido
        </div>}
      <div className={premium ? 'mt-2' : ''} data-id="element-276" data-mp="2a2073gis0xs9">
        <div className="flex items-start gap-2" data-id="element-277" data-mp="2eza5vms22lsr">
          <span className="text-3xl" data-id="element-278" data-mp="2f01v8fv27nal">{premium ? '🏆' : '📘'}</span>
          <h3 className={`headline text-xl ${premium ? 'text-white' : 'text-slate-900'}`} data-id="element-279" data-mp="2j0vdotpqg9w3">
            {title}
          </h3>
        </div>
        <p className={`mt-2 text-sm font-semibold ${premium ? 'text-sky-100' : 'text-slate-500'}`} data-id="element-280" data-mp="2nt52g6f433ws">
          {subtitle}
        </p>
      </div>

      <p className={`my-6 rounded-xl border p-4 text-sm leading-relaxed ${premium ? 'border-white/20 bg-white/10 text-sky-50' : 'border-celeste/40 bg-sky-50/70 text-slate-600'}`} data-id="element-281" data-mp="2xpi5huwjqu47">
        <b className={premium ? 'text-white' : 'text-slate-900'} data-id="element-282" data-mp="36q68zvobdc2u">Ideal para:</b>{' '}
        {premium ? 'Acompañantes Terapéuticos que trabajan con casos complejos, crisis frecuentes o varios pacientes a la vez y necesitan planificar a 90 días con objetivos técnicos medibles.' : 'Acompañantes Terapéuticos que quieren dejar de improvisar la sesión, tener protocolo ante crisis y documentar cada intervención con respaldo profesional.'}
      </p>

      <ul className="mb-6 flex-1 space-y-2" data-id="element-283" data-mp="v2kxlx8eel7v">
        {features.map(feature => <li key={feature} className={`flex items-start gap-2 text-sm font-medium ${premium ? 'text-white' : 'text-slate-700'}`} data-id="element-284" data-mp="r2118vvnflms">
            <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${premium ? 'text-amber-300' : 'text-accent'}`} data-id="element-285" data-mp="1npxim2ywukz2" />
            {feature}
          </li>)}
      </ul>

      <div className="mb-6" data-id="element-286" data-mp="1epinyd023tiw">
        <span className={`mb-3 inline-block rounded-full px-3 py-1 text-xs font-extrabold ${premium ? 'bg-gold text-white' : 'bg-celeste/25 text-primary-dark'}`} data-id="element-287" data-mp="19s8wkrt3x7sf">
          AHORRÁS {savings}
        </span>
        <p className={`mt-2 text-sm font-bold line-through ${premium ? 'text-sky-200' : 'text-slate-400'}`} data-id="element-288" data-mp="3ui82kvqld6se">
          Antes: {before}
        </p>
        <p className={`mt-1 text-xs font-bold uppercase ${premium ? 'text-sky-100' : 'text-slate-500'}`} data-id="element-289" data-mp="1r0hz6fwpzrhf">
          Hoy
        </p>
        <p className={`headline text-4xl ${premium ? 'text-white' : 'text-slate-900'}`} data-id="element-290" data-mp="1daeie4gm0pzd">{price}</p>
      </div>

      <Button href={premium ? purchaseUrls.premium : purchaseUrls.base} fullWidth className={premium ? 'border-2 border-amber-200 bg-gold text-[11px] ring-2 ring-gold/50 hover:bg-amber-600 md:text-sm' : 'text-[11px] md:text-sm'} data-id="element-291" data-mp="1hb85ivm8a0r7">
        {premium ? '👉 QUIERO COMBO COMPLETO + MEGA KIT DE INTERVENCIÓN' : '👉 QUIERO EL COMBO COMPLETO AT'}
      </Button>
    </article>;
}
type PricingProps = {
  id?: string;
  eyebrow?: string;
  title?: React.ReactNode;
};
export function Pricing({
  id = 'pricing',
  eyebrow = '💳 Tu opción hoy · Precio de lanzamiento activo',
  title = <>
      Asegurá el precio promocional <span className="text-accent" data-id="element-292" data-mp="h0p3p89zuz6w">antes de que suba.</span>
    </>
}: PricingProps) {
  return <section id={id} className="mx-auto max-w-6xl scroll-mt-16 px-4 py-16 md:py-24" data-id="element-293" data-mp="d2zp1qovj6bj">
      <div className="text-center" data-id="element-294" data-mp="r067tl9ll50r">
        <p className="text-[11px] font-extrabold uppercase tracking-[.16em] text-accent md:text-sm" data-id="element-295" data-mp="m1ldg2h11fk8">
          {eyebrow}
        </p>
        <h2 className="headline mx-auto mt-3 max-w-3xl text-2xl text-slate-900 md:text-4xl" data-id="element-296" data-mp="3uig8ivrl1vnr">
          {title}
        </h2>
        <div className="mt-6" data-id="element-297" data-mp="3pjwmywgwilvx">
          <Countdown data-id="element-298" data-mp="3pgh6pqbhr6sx" />
        </div>
        <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-299" data-mp="823krc0m1i5l">
          {['Después sube $9.000 ARS', 'Esta promo no vuelve', '72% de los cupos ya tomados'].map(item => <span key={item} className="inline-flex items-center gap-1 rounded-full border border-red-200 bg-red-50 px-3 py-1.5 text-[11px] font-bold text-red-600" data-id="element-300" data-mp="3bq5abf7vilvz">
                <AlertTriangleIcon className="h-3.5 w-3.5" data-id="element-301" data-mp="1anmmtu83cgu5" />
                {item}
              </span>)}
        </div>
      </div>

      <h2 className="headline mt-14 text-center text-2xl text-slate-900 md:text-4xl" data-id="element-302" data-mp="1keh7iu5ov8dh">
        Elegí tu <span className="text-accent" data-id="element-303" data-mp="1kgv3d5870om3">opción</span>
      </h2>
      <div className="mx-auto mt-10 grid max-w-5xl gap-8 md:grid-cols-2" data-id="element-304" data-mp="1ofkmlefwx0dn">
        <PlanCard data-id="element-305" data-mp="rqlfi2r2e4n1" />
        <PlanCard premium data-id="element-306" data-mp="rr4tj8dlg8vs" />
      </div>
      <p className="mt-9 text-center text-xs font-semibold text-slate-500" data-id="element-307" data-mp="rs68hnxqdfis">
        Pago 100% seguro · Mercado Pago hasta 12 cuotas · Acceso en 5 minutos · Garantía 7 días
      </p>
    </section>;
}